import React from 'react';
import PolotnoEditor from '../../editor/PolotnoEditor';

interface IProps {
    store: any;
    setIsEditorOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const CampaignEditor = ({ store, setIsEditorOpen }: IProps) => {
    return (
        <div className="tw-w-full tw-h-full tw-pt-6">
            <div
                className="tw-flex tw-items-center tw-gap-x-4 tw-mb-1 tw-py-1 tw-px-3 tw-cursor-pointer tw-rounded-md hover:tw-bg-gray-200 tw-w-fit"
                onClick={() => setIsEditorOpen(false)}
            >
                <span className="tw-text-lg tw-font-semibold">Edit Mode</span>
                <i className="ph-bold ph-x lg"></i>
            </div>
            <PolotnoEditor store={store} />
        </div>
    );
};

export default CampaignEditor;
